// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-pages-EntityCardPage-EntityHistory-EntityAudit-EntityAudit-module__auditFrame--if2Hx {
  height: 100%;
  overflow: auto;
  background-color: white;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
}
.src-pages-EntityCardPage-EntityHistory-EntityAudit-EntityAudit-module__title--MWBbW {
  padding: 20px 32px;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
}
.src-pages-EntityCardPage-EntityHistory-EntityAudit-EntityAudit-module__filterBox--tVHzZ {
  padding: 0 32px 24px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 16px;
}
.src-pages-EntityCardPage-EntityHistory-EntityAudit-EntityAudit-module__moreBox--S_ymp {
  padding: 1px 32px 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/EntityCardPage/EntityHistory/EntityAudit/EntityAudit.module.less"],"names":[],"mappings":"AAEA;EACE,YAAA;EACA,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AADF;AAIA;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAFF;AAKA;EACE,oBAAA;EACA,aAAA;EACA,8BAAA;EACA,gBAAA;AAHF;AAMA;EACE,mBAAA;AAJF","sourcesContent":["@horizSpace: 32px;\n\n.auditFrame {\n  height: 100%;\n  overflow: auto;\n  background-color: white;\n  border-radius: 4px;\n  display: flex;\n  flex-direction: column;\n}\n\n.title {\n  padding: 20px @horizSpace;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 150%;\n}\n\n.filterBox {\n  padding: 0 @horizSpace 24px;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  column-gap: 16px;\n}\n\n.moreBox {\n  padding: 1px @horizSpace 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"auditFrame": `src-pages-EntityCardPage-EntityHistory-EntityAudit-EntityAudit-module__auditFrame--if2Hx`,
	"title": `src-pages-EntityCardPage-EntityHistory-EntityAudit-EntityAudit-module__title--MWBbW`,
	"filterBox": `src-pages-EntityCardPage-EntityHistory-EntityAudit-EntityAudit-module__filterBox--tVHzZ`,
	"moreBox": `src-pages-EntityCardPage-EntityHistory-EntityAudit-EntityAudit-module__moreBox--S_ymp`
};
export default ___CSS_LOADER_EXPORT___;
